var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container app-container--academy"},[_c('header-academy'),_vm._v(" "),_c('div',{class:_vm.fullWidth ? false : "main-contents"},[_vm._t("default")],2),_vm._v(" "),_c('footer-academy')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f666eb86","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Academy/partials/AppContainerAcademy.vue
// module id = null
// module chunks = 